<div class="preloader-area">
    <div class="preloader">
        <span></span>
        <span></span>
    </div>
</div>